<template>
  <div>
    <el-popover class="avatar_popover" placement="bottom" trigger="click" :visible-arrow="false" width="240">
      <div class="content">
        <div class="details">
          <div class="text-16-M text_color_primary">
            {{ userInfo.phone }}
          </div>
          <div class="text-16-M text_color_active">
            {{ userInfo.role === roleArray[0]? '项目主管' : userInfo.role === roleArray[1]? '中心主任': userInfo.role === roleArray[2]? '超级管理员' : '' }}
          </div>
        </div>
        <div class="handle">
          <div class="update_pw text-14-M text_color_regular" @click="isShowUpdatePwDialog = true">
            修改密码
          </div>
          <div class="sign_out text-14-M text_color_regular" @click="signOut">
            退出登录
          </div>
        </div>
      </div>
      <div slot="reference" class="reference">
        <h1 class="text-14-m text_color_white">
          Hi，{{ userInfo.name }}
        </h1>
      </div>
    </el-popover>
    <el-dialog custom-class="my-el-dialog" :visible.sync="isShowUpdatePwDialog" width="400px" top="200px" :show-close="false" :close-on-click-modal="false">
      <div slot="title">
        <p class="dialog_title">修改密码</p>
      </div>
      <div class="change-pw-content">
        <el-form ref="pwdForm" :model="passwordData" :rules="rules" size="small" label-position="left" label-width="120px">
          <el-form-item label="原密码" prop="old_password">
            <el-input type="password" v-model="passwordData.old_password"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="new_password">
            <el-input type="password" v-model="passwordData.new_password"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 0px;" label="确认新密码" prop="confirm_password">
            <el-input type="password" v-model="passwordData.confirm_password"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="">
        <el-button size="small" @click="updatePwCanceled">取消</el-button>
        <el-button :loading="updatePwButtonLoading" size="small" type="primary" @click="confirmUpdatePw">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { role } from '~/utils/cadre.config'
import * as api from '~/api'
import SHA256 from 'crypto-js/sha256'
import cookie from '~/utils/cookie'
export default {
  data () {
    var confirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.passwordData.new_password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      // 是否显示修改密码的dialog
      isShowUpdatePwDialog: false,
      // 确定修改密码时的button的loading
      updatePwButtonLoading: false,
      // 密码
      passwordData: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      // 密码的验证
      rules: {
        old_password: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { pattern: /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d]{8,16}/, message: '密码长度为8~16位，至少需要包含数字、字母两种类型', trigger: 'blur' }
        ],
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { pattern: /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d]{8,16}/, message: '密码长度为8~16位，至少需要包含数字、字母两种类型', trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, message: '请输入确认新密码', trigger: 'blur' },
          { pattern: /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d]{8,16}/, message: '密码长度为8~16位，至少需要包含数字、字母两种类型', trigger: 'blur' },
          { validator: confirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 取消修改密码
    updatePwCanceled () {
      this.isShowUpdatePwDialog = false
      this.$refs['pwdForm'].resetFields()
    },
    // 确定修改密码
    confirmUpdatePw () {
      this.$refs['pwdForm'].validate((valid) => {
        if (valid) {
          this.updatePwButtonLoading = true
          api.chagePw({
            old_password: SHA256(this.passwordData.old_password).toString(),
            new_password: SHA256(this.passwordData.new_password).toString(),
            confirm_password: SHA256(this.passwordData.confirm_password).toString()
          }).then(res => {
            if (res.data.code === 0) {
              this.$message.success('修改密码成功')
              console.log(res.data)
              this.updatePwCanceled()
              // 退出
              this.signOut()
            } else {
              this.$message.error('修改密码失败')
              this.updatePwCanceled()
            }
            this.updatePwButtonLoading = false
          }).catch(err => {
            this.updatePwButtonLoading = false
            this.$message.error('网络错误，请检查网络设置')
            console.log(err)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 退出登录
    signOut () {
      // 删除token
      cookie.remove('token')
      // 重置vuex中用户的信息
      this.$store.commit('SET_USER_INFO', {})
      this.$router.push('/login')
    }
  },
  computed: {
    // 用户详细信息
    userInfo () {
      /*
        userInfo
          create_date:"2019-05-08 18:40:26"
          mini_roles:Array[3]
          name:"super_two"
          phone:"17371278540"
          role:"super_supervisor"
      */
      // 用户详细信息
      return this.$store.state.userInfo
    },
    // 身份列表
    roleArray () {
      return role
    }
  }
}
</script>
<style lang="scss" scoped>
  .content {
    display: flex;
    flex-direction: column;
    width: 100%;
    .details {
      display: flex;
      flex-direction: column;
      padding: 20px 0 20px 20px;
      & > div {
        display: flex;
        align-items: center;
        width: 100%;
        height: 32px;
      }
    }
    .handle {
      display: flex;
      height: 40px;
      width: 100%;
      border-top: 1px solid $border-color-base;
      .update_pw, .sign_out {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        cursor: pointer;
        &:hover {
          color: $color-text-primary;
        }
      }
      .update_pw {
        border-right: 1px solid $border-color-base;
      }
    }
  }
  .reference {
    display: flex;
    align-items: center;
    justify-content: center;
    // width: 105px;
    padding: 0 20px;
    height: $layout-header-height;
    transition: 0.3s ease;
    cursor: pointer;
    &:hover {
      background-color: $--color-primary-light-2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/header/header-avatar.vue